import React, { useCallback, useEffect, useState } from 'react'
import Table from "../Components/Table/Table";
import { Link, useParams } from "react-router-dom";
import { Api } from "../../../helpers/Api";
import Heading from "../Components/Heading/Heading";
import columnConfig from "../Main/Dashboard/columns";
import { connect } from "react-redux";
import Popup from "../Components/PopUp/Popup";
import SearchUI from '../Search/SearchUI';
import { jsPDF } from "jspdf";
import JSZip from "jszip";
import { saveAs } from 'file-saver';

const Team = ({ user, ...props }) => {


    const params = { path: 'certificates' };
    let config = columnConfig[params.path];
    const [state, setState] = useState({
        loading: true,
        error: null,
        config: config,
        page: 1,
        limit: 10,
        total: 0,
        show: false,
    });

    let zip = new JSZip();
    let img = null;
    const [filter, setFilter] = useState('');
    const [posts, setPosts] = useState([]);
    const [total, setTotal] = useState(-1);
    const [name, setName] = useState("Download");
    const [filterData, setFilterData] = useState([]);
    const [buttonProcessing, setButtonProcessing] = useState("Download Certificate");


    const { id: templateId } = useParams();

    const loadData = useCallback(() => {
        setState(s => {
            return { ...s, loading: true }
        });
        let start = 0;
        const limit = state.limit;
        const page = state.page;

        start = (page - 1) * limit;
        Api.call(`/${config.url}/count?template=${templateId}`).then(response => {
            setTotal(response);

        });

        if (filter.query) {
            if (filterData.selector == "email") {

                Api.call(`/FindByEmail?id=${templateId}&${filter.query}`).then(response => {
                    let d = [];
                    d = response;
                    setPosts(d)
                }).catch(console.log).finally(_ => {
                    setState(s => {
                        return { ...s, loading: false }
                    });
                });
            }
            else {
                // Api.call(`/${link}?end_date_lte=${date}&_sort=id:DESC&_limit=100&_start=${start}&${filter.query}`).then(response => {
                Api.call(`/${config.ur}?&_sort=id:DESC&_limit=1000&_start=${start}&${filter.query}`).then(response => {
                    let d = [];
                    d = response;
                    setPosts(d)
                }).catch(console.log).finally(_ => {
                    setState(s => {
                        return { ...s, loading: false }
                    });
                });
            }
        }

        else {
            Api.call(`/${config.url}?template=${templateId}&_sort=id:DESC&_limit=${limit}&_start=${start}`).then(response => {
                setPosts(response)
            }).catch(console.log).finally(_ => {
                setState(s => {
                    return { ...s, loading: false }
                });
            });
        }
    }, [config.url, state.page, filter, state.limit]);

    const onPaginate = (page) => {
        setState({ ...state, page: page, loading: true })
    };

    useEffect(() => {
        if (!user) {
            return;
        }
        loadData()
    }, [loadData, params.path, user]);


    const parsePatient = (post) => {
        let row = state.config.columns.map((column) => {
            if (column.accessor) {
                return column.accessor(post);
            }
            return post[column.key];
        });
        console.log({ row });
        return row;
    };

    const renderRow = (row, index) => {
        let columnIndex = 0;
        let patient = parsePatient(row);
        return <tr key={index}>
            <td key={index}>{`${(state.page - 1) * state.limit+(index+1)}`}</td>
            {patient.map(column => {
                return renderColumn(column, columnIndex++, index, patient, row);
            })}</tr>
    };

    const selectAll = () => {
        let allSelected = !state.allSelected;
        let row = state.row.map(patient => {
            patient.selected = allSelected;
            return patient;
        });
        setState({ ...state, row: row, allSelected: allSelected });
    };

    const onDelete = (event, index) => {
        event.preventDefault();
        if (!window.confirm('Are you sure you want to delete this item?')) {
            return;
        }
        let post = posts[index];
        Api.call(`/${config.url}/${post.id}`, "DELETE").then(response => {
            loadData();
        })
    };

    const onUp = (event, index) => {
        event.preventDefault();
        setState({ ...state, loading: true })
        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/up`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const onDown = (event, index) => {
        setState({ ...state, loading: true })
        event.preventDefault();

        let post = posts[index];
        Api.call(`/${config.url}/${post.id}/move/down`, "POST").then(response => {

        }).catch(() => {

        }).finally(loadData)
    };

    const showSearchbox = (boolean) => {
        setState(s => {
            return { ...s, showSearch: boolean }
        })
    }

    const filterBuilder = (query) => {
        setFilter(query);
        console.log(query);
    }

    const renderColumn = (column, index, rowIndex, row, originalRow) => {
        if (index === row.length - 1) {

            if (state.config.renderActions) {
                return state.config.renderActions(column, index, rowIndex, row, originalRow, onUp, onDown, onDelete, state, config);
            } else {
                return <td key={index}>
                    <ul>
                        <li>
                            <Link to={`/${config.url}/${originalRow.id}`}>
                                {columnConfig.editIcon}

                            </Link>
                        </li>
                        <li>
                            <Link to="/" onClick={e => onDelete(e, rowIndex)}>
                                {columnConfig.deleteIcon}
                            </Link>
                        </li>
                    </ul>
                </td>
            }

        }
        if (typeof column === "boolean") {
            return <td key={index}><span style={{ color: column ? "green" : "red" }}>{column ? "Yes" : "No"}</span></td>
        }
        return <td key={index}>{column}</td>
    };
    const renderHeaderColumn = (column, index) => {

        return (
            <th key={index}>
                {column.name}
            </th>
        );
    };

    const download = (d, count) => {

        let data = d?.templateData;
        
        var pdf = new jsPDF('l', 'px', [500, 800]);

        pdf?.addImage(data?.backgroundImageUrl.replace("itmatic.io", "codebrigade.in"), 'JPEG', 0, 0, 800, 500, '','FAST');

        {
            data?.images?.length !== 0 && data?.images?.map((text, index) => {
                pdf?.addImage(text?.url?.replace("itmatic.io", "codebrigade.in"), 'JPEG',
                    text?.x * 1.30, text?.y * 1.27,
                    text?.width, text?.height, '','FAST');
            });
        }

        if (data?.qrCode !== null ) {
            let qrUrl = 'https://api.qrserver.com/v1/create-qr-code/?size=50x50&data=https://events.chitkara.edu.in/certificate/' + d.id;
            let x = !data.qrCode.x ? 0 : data.qrCode?.x * 1.228;
            let y = !data.qrCode.y ? 0 : data.qrCode?.y * 1.12;
            pdf?.addImage(qrUrl, 'JPEG', x, y, 60, 60);
        }

        data?.label?.map((text) => {
            const size = text.fontSize / 0.75; // convert pixels to points
            pdf?.setFontSize(size);
            pdf?.setTextColor(text?.color);
            if (text?.align === "center") {
                let x = ((text.x * 1.25) + (text.width / 1.7));
                pdf?.text(`${d.data[text.text]}`, x, text?.y * 1.11, {
                    baseline: 'top',
                    color: text?.color,
                    maxWidth: text?.width,
                    align: 'center',
                });
            }
            else {
                let x = text?.x * 1.25;
                pdf?.setTextColor(text?.color);
                pdf?.text(`${d.data[text.text]}`, x, text?.y * 1.11, {
                    baseline: 'top',
                    color: text?.color,
                    maxWidth: text?.width,
                    align: 'left'
                });
            }
        });
        if(img){
            img.file(`${d.data?.name || d.data?.Name || d.data?.Label}(${d.id}).pdf`, pdf.output("blob"), {base64: true});
        }
        setTimeout(() => {
            DownloadCertificate(count + 1);
        }, 1000)
    }

    const DownloadCertificate = (length) => {
        if(img === null){
            img = zip.folder(`${posts[length].templateData?.TemplateName}`);
        }
        document.getElementsByClassName("Download_Cert")[0].innerText = `${length + 1}/${posts.length}`;
        if (posts.length == length) {
            zip.generateAsync({type:"blob"}).then(function(content) {
                saveAs(content,`${posts[1].templateData?.TemplateName}.zip`);
            });
            img = null;
            zip = new JSZip();
            document.getElementsByClassName("Download_Cert")[0].innerText = `Download Certificate`;
            return;
        }
        else {
            download(posts[length], length);
        }
    };

    return (
        <div className="right_container">
            <Popup okBtn={true} trigger={state.showSearch} setSearch={showSearchbox} heading={<div className='search'><h5 className="search-title">Filter</h5>
                <p>Please search here by fields name.</p></div>}>
                <SearchUI filterBuilder={filterBuilder} data={filterData} setData={setFilterData} name="certificates"></SearchUI>
            </Popup>
            <div className="dashboard">
            {/* Button={{ callbackfunction: () => { DownloadCertificate(0) } }} */}
                <div className='inner-content'>
                    <Heading total={total} name={config.name} onRefresh={loadData} search={true} setSearchBox={showSearchbox}
                        Import={`/certificates/csv`}  refreshlink="#" link={`/${config.url}/${templateId}`}
                        linkName="Add New" url={params.path} />
                    <div className='commen-table'>
                        <Table serial={true} renderColumn={renderColumn} loading={state.loading}
                            renderRow={renderRow} renderHeaderColumn={renderHeaderColumn}
                            columns={state.config.columns} cardFooter="cardFooter" total={total}
                            currentPage={state.page} perPage={state.limit} filter={filter}
                            rows={posts} selected="Invite Selected" onPaginate={onPaginate}
                            onChangePerPage={(limit) => {
                                setState({ ...state, limit });
                            }}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatchLogin: (user) => dispatch({ type: 'LOGIN', data: user })
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Team)
